import "phaser";
import { Game, Direction } from "../app/game";
import App, { PHONE_TYPE } from "../main";

export class Gem {
    public gemSprite: Phaser.GameObjects.Sprite;

    public firstGem: Phaser.Physics.Matter.Sprite;

    private game;

    index: number;

    gemCollectAudio: Phaser.Sound.HTML5AudioSound;

    constructor(game: Phaser.Scene, x: number, y: number, gemNo: number) {
        this.game = game;

        this.gemSprite = game.add.sprite(x, y, 'spritesAtlaas', 'gem.png');
        if (gemNo == 0) {
            this.firstGem = game.matter.add.sprite(x, y, 'spritesAtlaas', 'empty.png', {});
            this.firstGem.setRectangle(300, 300, { isSensor: true })
        }
        this.index = gemNo;

        game.matter.world.on('collisionstart', this.onCollisionStart.bind(this));

        this.gemCollectAudio = this.game.sound.add('gem')
        this.game.events.on('chevron', () => { this.TweenGem() });

    }


    onCollisionStart(event, bodyA, bodyB) {
        // if ((bodyA == this.collider.body && bodyB == Game.car.carSprite.body) || (bodyA == Game.car.carSprite.body && bodyB == this.collider.body)) {
        // }
        if (this.index == 0) {
            if ((bodyA.parent == this.firstGem.body && bodyB.parent == Game.car.carSprite.body) || (bodyA.parent == Game.car.carSprite.body && bodyB.parent == this.firstGem.body)) {

                if (this.index == 0) {
                    Game.car.CarSpeedUp(this.gemSprite.x, this.gemSprite.y);
                    this.game.LevelUp();
                    this.game.IncreaseStreakScore(19);
                }
                this.firstGem.setCollisionCategory(Game.disableCollisionLayer);
                this.game.events.emit('chevron');
            }
        }
    }

    TweenGem() {
        this.game.time.addEvent({
            delay: this.index * 50,
            callback: () => {
                this.game.tweens.add({
                        targets: this.gemSprite,
                        visible: 0,
                        duration: 150
                    })

                    this.game.tweens.add({
                            targets: this.gemSprite,
                            scale: 3,
                            duration: 200
                        })
                // this.game.IncreaseScore();
                if (Game.sfxOn) {
                    this.gemCollectAudio.play()
                }

            },
            callbackScope: this
        })
    }
}
